import AboutUs from 'routes/AboutUs'

export default AboutUs
